(() => {
  const body = document.body;
  const menu = document.querySelector('[data-chi-mobile-menu]');
  const menuToggle = document.querySelector('[data-chi-menu-toggle]');
  const cartDrawer = document.querySelector('[data-chi-cart-drawer]');
  const freeShippingCents = 7500;
  const money = new Intl.NumberFormat(undefined, { style: 'currency', currency: document.documentElement.dataset.currency || 'USD' });

  const setMenu = (open) => {
    if (!menu || !menuToggle) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    menuToggle.setAttribute('aria-expanded', String(open));
    body.classList.toggle('chi-locked', open);
  };

  const setCart = (open) => {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle('is-open', open);
    cartDrawer.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('chi-locked', open);
  };

  const escapeHTML = (value = '') => value.replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[char]));

  const updateCartCounts = (count) => document.querySelectorAll('.chi-cart-count').forEach((node) => { node.textContent = count; });

  const renderCart = (cart) => {
    const items = cartDrawer?.querySelector('[data-chi-cart-items]');
    const foot = cartDrawer?.querySelector('[data-chi-cart-foot]');
    const message = cartDrawer?.querySelector('[data-chi-cart-message]');
    const progress = cartDrawer?.querySelector('[data-chi-cart-progress]');
    const total = cartDrawer?.querySelector('[data-chi-cart-total]');
    if (!items || !foot || !message || !progress || !total) return;
    updateCartCounts(cart.item_count);
    const remaining = Math.max(freeShippingCents - cart.total_price, 0);
    progress.style.width = `${Math.min((cart.total_price / freeShippingCents) * 100, 100)}%`;
    message.textContent = remaining ? `Add ${money.format(remaining / 100)} for complimentary U.S. shipping.` : 'Your bag qualifies for complimentary U.S. shipping.';
    if (!cart.items.length) {
      items.innerHTML = '<div class="chi-cart-empty"><p class="chi-display">Your bag is waiting.</p><a class="chi-text-link" href="/collections/all">Explore the collection</a></div>';
      foot.hidden = true;
      return;
    }
    items.innerHTML = cart.items.map((item) => `
      <article class="chi-cart-item">
        <img src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title)}">
        <div><p class="chi-cart-item__title">${escapeHTML(item.product_title)}</p><p>${escapeHTML(item.variant_title || '')}</p><p>${money.format(item.final_line_price / 100)}</p><button type="button" data-chi-cart-remove="${item.key}">Remove</button></div>
      </article>
    `).join('');
    total.textContent = money.format(cart.total_price / 100);
    foot.hidden = false;
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
  };

  document.addEventListener('click', async (event) => {
    const menuOpen = event.target.closest('[data-chi-menu-toggle]');
    if (menuOpen) { event.preventDefault(); setMenu(true); return; }
    if (event.target.closest('[data-chi-menu-close]')) { setMenu(false); return; }
    const cartOpen = event.target.closest('[data-chi-cart-toggle]');
    if (cartOpen) { event.preventDefault(); await refreshCart(); setCart(true); return; }
    if (event.target.closest('[data-chi-cart-close]')) { setCart(false); return; }
    const remove = event.target.closest('[data-chi-cart-remove]');
    if (remove) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: remove.dataset.chiCartRemove, quantity: 0 }) });
      await refreshCart();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    button?.setAttribute('disabled', 'disabled');
    try {
      await fetch(form.action, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      await refreshCart();
      setCart(true);
    } finally {
      button?.removeAttribute('disabled');
    }
  });
})();
